import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { Id } from '../types'

export const rcuDelete = async (payload: Id) => {
  const response = await axios.delete(`${getAPIService}/v2/api/rcus/${payload}`)
  return response.data
}
